export default {
  namespaced: true,
  state: {
    center: {lat: null, lng: null},
    pencilIconSelected: false,
    pencilIconSelectedAlt: false,
    bounds: {},
    boundsalt: {}
  },
  getters: {
    pencilIconSelected: (state) => {
      return state.pencilIconSelected;
    },
    pencilIconSelectedAlt: (state) => {
      return state.pencilIconSelectedAlt;
    },
    bounds: (state) => {
      return state.bounds;
    },
    boundsalt: (state) => {
      return state.boundsalt;
    },
    center: (state) => {
      return state.center;
    }
  },
  mutations: {
    setCenter (state, center) {
      if (typeof (center.latLng) === 'string') {
        state.center = JSON.parse(center.latLng);
      } else {
        state.center.lat = center.latLng.lat;
        state.center.lng = center.latLng.lng;
      }
    },
    setPencilIconSelected (state, toggle) {
      state.pencilIconSelected = toggle;
    },
    setPencilIconSelectedAlt (state, toggle) {
      state.pencilIconSelectedAlt = toggle;
    },
    setBounds (state, bounds) {
      state.bounds = bounds;
    },
    setBoundsAlt (state, boundsalt) {
      state.boundsAlt = boundsalt;
    }
  },
  actions: {
    setCenter ({commit}, center) {
      commit('setCenter', center);
    },
    togglePencilIconSelected ({commit}, toggle) {
      commit('setPencilIconSelected', toggle);
    },
    togglePencilIconSelectedAlt ({commit}, toggle) {
      commit('setPencilIconSelectedAlt', toggle);
    },
    setBounds ({commit}, bounds) {
      commit('setBounds', bounds);
    },
    setBoundsAlt ({commit}, boundsalt) {
      commit('setBoundsAlt', boundsalt);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/mapModule.js